/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-comment': {
    width: 13,
    height: 12,
    viewBox: '0 0 13 12',
    data: '<path pid="0" d="M12.5.159H.649a.5.5 0 0 0-.5.5v7.785a.517.517 0 0 0 .5.5h2.659l.056 2.06a.5.5 0 0 0 .5.5.433.433 0 0 0 .317-.116l3.428-2.443h4.89a.517.517 0 0 0 .501-.5V.658a.5.5 0 0 0-.5-.5zM2.657 2.693H7.36v1H2.657v-1zm7.903 3.4H2.657v-1h7.903v1z" _fill="#687E8A" fill-rule="nonzero"/>'
  }
})
